export default __webpack_public_path__ + "static/ituFunds-c75c63c0e998405c7ad09e2797d8e347.svg";